import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import CryptoJS from "crypto-js";
import { TextInput, SelectInput, MoneyInput } from "../../Components";
import { storageHandler } from "../../Helpers";

import { influencerlistService, jobCampaignsService } from "../../Services";
import AppTextArea from "../../Components/Base/Form/AppTextArea";
import { SwitchWithLabel } from "../../Components/AppSwitchWithLabel";

const initForm = {
  product: "",
  pieceOfContent: "",
  time: "",
  timespan: "",
  rate: "",
  platform_user_id: "",
  ds_campaign_title: "",
  ds_campaign_delivery_info: "",
  brand_profile_id: "",
  ds_campaign_delivery_date: "",
};
const timeFrame = [
  { id: "seconds", value: "Seconds" },
  { id: "minutes", value: "Minutes" },
  { id: "hours", value: "Hours" },
];
export default function AddOffer({
  user,
  setShowCart,
  listInfluencer,
  listDetails,
  setModal,
  setTab,
  setToastList,
  toastList,
  setTabModal,
  setCartItem,
  cartItem,
  influencerProfile,
}) {
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const createList = useRef(null);
  const [form, setForm] = useState(initForm);
  const [error, setError] = useState(false);
  const [productList, setProductList] = useState([]);
  const [totalAmountOfOffer, setTotalAmountOfOffer] = useState(0);
  const [disableButton, setDisableButton] = useState(false);
  const [isStartDatePickerOpen, setIsStartDatePickerOpen] = useState(false);
  const [brandProfilesList, setBrandProfilesList] = useState([]);
  const [paymentEnabled, setPaymentEnabled] = useState(true);

  useEffect(() => {
    fetchBrandProfiles();
  }, []);

  useEffect(() => {
    const rateValue = parseFloat(form.rate) || 0;
    const influencerCount = listInfluencer.length;
    setTotalAmountOfOffer(rateValue * influencerCount);
  }, [form.rate, listInfluencer.length]);

  const fetchBrandProfiles = async () => {
    try {
      const res = await jobCampaignsService.getBrandProfiles();
      if (res.success === true) {
        const updatedPlatforms = res?.data.map(({ id, brand_name }) => ({
          id: String(id),
          label: String(id),
          value: brand_name,
        }));
        setBrandProfilesList(updatedPlatforms);
        if (updatedPlatforms.length === 1) {
          updateForm({ brand_profile_id: updatedPlatforms[0].id });
        }
      }
    } catch (err) {
      console.log("🚀 ~ fetchBrandProfiles ~ err:", err);
    }
  };

  // const changeBrandProfile = (brand) => {
  //   console.log("Selected brand received:", brand, typeof brand);

  //   let brandId;
  //   if (typeof brand === "string") {
  //     brandId = brand;
  //   } else if (brand && brand.id) {
  //     brandId = brand.id;
  //   } else {
  //     console.error("Invalid brand selection:", brand);
  //     return;
  //   }

  //   setForm((prev) => ({ ...prev, brand_profile_id: brandId }));
  // };
  const changeBrandProfile = (brandId) => {
    updateForm({ brand_profile_id: brandId });
  };

  const getSelectedBrandProfile = () => {
    return (
      brandProfilesList.find(
        (brand) => brand.id === String(form.brand_profile_id)
      ) || null
    );
  };

  const updateForm = (data) => {
    setForm({ ...form, ...data });
  };
  console.log("form.rate", form.rate);

  const setInput = (key) => (event) => {
    updateForm({ [key]: event.target.value });
  };

  useEffect(() => {
    updateForm({ rate: 100 });
  }, []);

  const encryptData = (data, secretKey) => {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  useEffect(() => {
    async function fetchProducts() {
      try {
        const res = await influencerlistService.fetchProducts();
        if (res) {
          let productArray = [];
          try {
            const resP = await influencerlistService.fetchCount(listDetails.id);
            console.log("🚀 ~ fetchProducts ~ resP:", resP);

            if (resP?.success && resP.data) {
              let countdata = resP.data;

              if (res.data && Array.isArray(res.data)) {
                res.data.forEach((itema) => {
                  let validProduct = countdata.filter(
                    (item) => item.product_id === itema.id
                  );

                  if (validProduct.length > 0) {
                    productArray.push({
                      count: validProduct[0]["count"] || 0,
                      id: itema.id,
                      value: itema.name,
                      label: itema.name,
                      socialId: itema.social_media_id,
                    });
                  }
                });
              }
            }
            setProductList(productArray);
          } catch (err) {
            addToast({
              error: true,
              msg: err,
              id: `${Date.now()}-${toastList.length}`,
            });
          }
        }
      } catch (err) {
        addToast({
          error: true,
          msg: err,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }
    fetchProducts();
  }, []);

  const getCountOfInf = (selectedProduct) => {
    console.log(
      "Selected product received:",
      selectedProduct,
      typeof selectedProduct
    );

    let productObj;
    if (
      typeof selectedProduct === "string" ||
      typeof selectedProduct === "number"
    ) {
      productObj = productList.find((p) => p.id === selectedProduct);
    } else if (selectedProduct && selectedProduct.id) {
      productObj = selectedProduct;
    }

    if (!productObj || !productObj.id) {
      console.error("Invalid product selection:", selectedProduct);
      return;
    }

    setForm((prev) => ({
      ...prev,
      product: productObj.id,
    }));

    if (productObj.count === 0) {
      setDisableButton(true);
    } else {
      setDisableButton(false);
    }
  };

  const changeSpanTime = (selectedTimeFrame) => {
    let timespanId;
    if (typeof selectedTimeFrame === "string") {
      timespanId = selectedTimeFrame;
    } else if (selectedTimeFrame && selectedTimeFrame.id) {
      timespanId = selectedTimeFrame.id;
    } else {
      console.error("Invalid timeframe selection:", selectedTimeFrame);
      return;
    }

    setForm((prev) => ({
      ...prev,
      timespan: timespanId,
    }));
  };

  const submitBtnClick = async () => {
    let allCartNeedToAdd = [];
    if (
      form.product === "" ||
      form.time === "" ||
      form.timespan === "" ||
      form.rate === "" ||
      form.pieceOfContent === "" ||
      form.ds_campaign_title === "" ||
      form.hashtag === "" ||
      form.ds_campaign_delivery_info === "" ||
      form.brand_profile_id === "" ||
      form.ds_campaign_delivery_date === ""
    ) {
      setError(true);
    } else {
      let productId = productList.filter((item) => item.id === form.product);

      try {
        const eligibleInfluencer =
          await influencerlistService.getElgibleInfluencer(
            listDetails.id,
            form.product
          );
        if (eligibleInfluencer.success === true) {
          eligibleInfluencer.data.map((item) => {
            let allAccountOfUser = eligibleInfluencer.data.filter(
              (infItem) => infItem.user_id === item.user_id
            );
            let filteredCount = allAccountOfUser.length;
            let newObject = {
              offer_type: "custom",
              time: form.time,
              timespan: form.timespan,
              pieceOfContent: form.pieceOfContent,
              quantity: form.pieceOfContent,
              price: form.rate,
              to_user_type: item.type,
              followers_count: item.followers.toString(),
              influencerAccountCount: filteredCount,
              description:
                form.pieceOfContent +
                " " +
                productId[0].value +
                " (" +
                form.time +
                " " +
                form.timespan +
                ")" +
                (filteredCount > 1
                  ? "- Followerscount -" + item.followers
                  : ""),
              product_id: item.product_id,
              product: productId[0].value,
              platform_user_id: item.pt_user_id,
              profileName: item.display_name,
              profileImage: item.profile_image_url,
              cart_item_addedBy: user.data.id,
              to_user_id: item.user_id,
              ds_campaign_title: form.ds_campaign_title,
              hashtag: form.hashtag,
              ds_campaign_delivery_info: form.ds_campaign_delivery_info,
              ds_campaign_delivery_date: form.ds_campaign_delivery_date,
              brand_profile_id: form.brand_profile_id,
              tama_payment: paymentEnabled ? 1 : 0,
            };
            allCartNeedToAdd.push(newObject);
          });

          setCartItem([...cartItem, ...allCartNeedToAdd]);

          let encrypteddata = encryptData(
            JSON.stringify([...cartItem, ...allCartNeedToAdd]),
            secretKey
          );
          storageHandler.setCartItem(encrypteddata);
        }
      } catch (err) {
        addToast({
          error: true,
          msg: err,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
      setTabModal(null);
      setShowCart(true);
    }
  };
  const addToast = (data) => {
    const newToastList = [...toastList];
    if (data.msg) {
      if (data.msg[data.msg.length - 1] === ".")
        data.msg = data.msg.slice(0, -1);
    }
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };
  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        createList.current.click();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [form]);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const handleStartDateClick = (e) => {
    if (isStartDatePickerOpen) {
      e.currentTarget.blur();
      setIsStartDatePickerOpen(false);
    } else {
      e.currentTarget.showPicker();
      setIsStartDatePickerOpen(true);
    }
  };

  const getSelectedProduct = () => {
    return productList.find((temp) => temp.id === form.product) || null;
  };

  const getSelectedTimeFrame = () => {
    return timeFrame.find((item) => item.id === form.timespan) || null;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      exit={{ opacity: 0, y: 30 }}
      className="assetsAdd"
    >
      <div className="assetsAdd__form">
        <div className="assetsAdd__form-title">
          <h3 className="big">Create a Custom Offer</h3>
        </div>
        <div
          className="max-h-[65vh] overflow-y-auto pr-2"
          style={{
            scrollbarWidth: "thin",
            scrollbarColor: "#e5e7eb transparent",
          }}
        >
          <div className="assetsAdd__form-inner !mb-2">
            <div className="assetsAdd__form-head">
              <SelectInput
                errorText="Please enter what kind of content do you need?"
                list={productList}
                selected={getSelectedProduct()}
                error={error && form.product === ""}
                value={form.product}
                onChange={getCountOfInf}
                label="What kind of content do you need?"
                className={`${
                  error && !form.product ? "border-[#980412] bg-red-50 " : ""
                }`}
                isRequired
              />
            </div>
          </div>
          <div className="assetsAdd__form-inner !mb-2">
            <div className="addOffer">
              <div className="w-full">
                <TextInput
                  onChange={setInput("time")}
                  type="number"
                  label="How long should the content be?"
                  errorText="Please enter how long should the content be"
                  readOnly={false}
                  error={error}
                  value={form.time}
                  isRequired
                />
              </div>
              <SelectInput
                onChange={changeSpanTime}
                label="TimeFrame"
                list={timeFrame}
                value={form.timespan}
                selected={getSelectedTimeFrame()}
                error={error && form.timespan === ""}
                errorText="Please select TimeFrame"
                isRequired
                className={`${
                  error && !form.timespan ? "border-[#980412] bg-red-50 " : ""
                }`}
              />
            </div>
          </div>

          <div className="assetsAdd__form-inner !mb-2 ">
            <div className="addCalculation">
              <MoneyInput
                label="Set a price for each Influencer"
                type="number"
                currency="$"
                error={error}
                value={form.rate}
                disabled={false}
                readOnly={false}
                onChange={setInput("rate")}
              />
            </div>
            <div className="input__outer countofOfferCalculation">
              <div className="calulationOperation2"> X</div>
              <div>
                <TextInput
                  label="# of Influencers"
                  readOnly={true}
                  value={listInfluencer.length}
                />
              </div>
              <div className="calulationOperation2">=</div>
              <div className="calulationOperation">
                <TextInput
                  readOnly={true}
                  label="Total"
                  value={"$" + totalAmountOfOffer}
                />
              </div>
            </div>
          </div>
          <div className="!mb-2">
            <TextInput
              onChange={setInput("pieceOfContent")}
              type="number"
              label="Pieces of content do you need?"
              errorText="Please enter how many pieces of content do you need"
              readOnly={false}
              error={error}
              value={form.pieceOfContent}
              isRequired
            />
          </div>
          <div className="grid grid-cols-2 gap-2 !mb-2">
            <div className="assetsAdd__form-head">
              <SelectInput
                errorText="Please select brand profile"
                list={brandProfilesList}
                selected={getSelectedBrandProfile()}
                onChange={changeBrandProfile}
                label="Brand Profile"
                error={error && form.brand_profile_id === ""}
                isRequired
                value={form.brand_profile_id}
                className={`p-3 ${
                  error && !form.brand_profile_id
                    ? "border-[#980412] bg-red-50 "
                    : ""
                }`}
              />
            </div>

            {/* Delivery Date */}
            <div className="">
              <label className="block text-[14px] text-black font-semibold  mb-1">
                Campaign Delivery Date <span className="text-red-400">*</span>
              </label>
              <div
                className={`border p-[9px] border-gray-200 rounded-md ${
                  error && !form.ds_campaign_delivery_date
                    ? "!border-[#980412] bg-red-50 "
                    : ""
                }`}
              >
                <input
                  type="date"
                  id="ds_campaign_delivery_date"
                  value={form.ds_campaign_delivery_date || ""}
                  onChange={(e) =>
                    updateForm({ ds_campaign_delivery_date: e.target.value })
                  }
                  min={getTodayDate()}
                  onKeyDown={(e) => e.preventDefault()}
                  onClick={handleStartDateClick}
                  className={`bg-white w-full outline-none cursor-pointer text-black disabled:opacity-50 disabled:cursor-not-allowed [&::-webkit-calendar-picker-indicator]:cursor-pointer ${
                    error && !form.ds_campaign_delivery_date
                      ? "!bg-red-50 "
                      : ""
                  }`}
                />
              </div>
              {error && !form.ds_campaign_delivery_date && (
                <p className="text-[#980412] text-[12px] flex items-center gap-2">
                  Please enter campaign delivery date
                </p>
              )}
            </div>
          </div>
          <div className="!mb-2">
            <TextInput
              onChange={setInput("ds_campaign_title")}
              type="text"
              onWheel={(e) => e.target.blur()}
              label="Campaign Title"
              errorText=" Please enter campaign title"
              error={error && form.ds_campaign_title === ""}
              value={form.ds_campaign_title}
              isRequired
            />
          </div>
          <div className="!mb-2">
            <TextInput
              onChange={setInput("hashtag")}
              type="text"
              onWheel={(e) => e.target.blur()}
              label="Hashtag"
              errorText=" Please enter hashtag"
              error={error && form.hashtag === ""}
              value={form.hashtag}
              isRequired
            />
          </div>
          <div className="">
            <AppTextArea
              onChange={setInput("ds_campaign_delivery_info")}
              type="text"
              rows={3}
              onWheel={(e) => e.target.blur()}
              error={error && form.ds_campaign_delivery_info === ""}
              label="Campaign Delivery Information"
              errorText=" Please enter campaign delivery information"
              value={form.ds_campaign_delivery_info}
              isRequired
              textAreaLable="!text-black !font-semibold"
              errorClassName="!text-[12px] !text-[#980412]"
              className={`focus:ring-0 focus:outline-none ${
                error && form.ds_campaign_delivery_info === ""
                  ? "border-[#980412] bg-red-50"
                  : ""
              }`}
            />
          </div>
        </div>
      </div>

      <div className="campaignsCreate__btns">
        <div className="campaignsCreate__btns-row">
          <SwitchWithLabel
            id="notifications"
            label="Payments Handled By TAMA"
            labelRight=""
            className=""
            checked={paymentEnabled}
            onCheckedChange={setPaymentEnabled}
          />
        </div>
        <button
          ref={createList}
          disabled={disableButton}
          className="button primary"
          onClick={submitBtnClick}
        >
          Add To Cart
        </button>
      </div>
    </motion.div>
  );
}
